import React from "react";
import LibraryAddRoundedIcon from "@mui/icons-material/LibraryAddRounded";

const AddToLibrary = () => {
  return (
    <div>
      <button
        className="orange-filled-btn addcommunitybtn"
        // onClick={() => setUploadModalShow(true)}
      >
        <LibraryAddRoundedIcon />
        Add to Library
      </button>
    </div>
  );
};

export default AddToLibrary;
